import { FC } from 'react';

import { ApplicationStatus } from 'entities/application/ui/ApplicationStatus/ApplicationStatus';
import {
	DeveloperStyled,
	HeaderDescriptionStyled,
	HeaderStyled,
	LogoMStyled,
	NameContainerStyled,
	NameStyled,
} from './ApplicationHeaderM.styles';

interface ApplicationHeaderMProps {
	name: string;
	description: string;
	logoUrl: string;
	status?: 'development' | 'new' | 'trial';
}

export const ApplicationHeaderM: FC<ApplicationHeaderMProps> = ({ name, description, logoUrl, status }) => (
	<HeaderStyled>
		<LogoMStyled src={logoUrl} />
		<HeaderDescriptionStyled>
			<NameContainerStyled>
				<NameStyled>{name}</NameStyled>
			</NameContainerStyled>
			<DeveloperStyled>{description}</DeveloperStyled>
			{status && <ApplicationStatus status={status} />}
		</HeaderDescriptionStyled>
	</HeaderStyled>
);
